import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PlanOfferModal from './PlanOfferModal';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth();
  const location = useLocation();

  // Show a full-page spinner while the session is being restored from storage
  if (loading) {
    return (
      <div className="h-screen w-full flex items-center justify-center bg-paper-bg">
        <div className="w-8 h-8 rounded-full border-4 border-surface-container-high border-t-primary-container animate-spin" />
      </div>
    );
  }

  // No session → send to login, but remember where they were going
  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <>
      <PlanOfferModal />
      {children}
    </>
  );
}
